<div class="hero-section">
    <app-menu-bar></app-menu-bar>
    <div class="overlay-content">
        <span class="title">{{ 'terms_title' | translate }}</span>
        @if (lastUpdated) {
            <span class="subtitle">{{ 'terms_last_updated' | translate }} {{ lastUpdated }}</span>
        }
    </div>
</div>

<section class="terms-section">
    <div class="terms-body">
        @for (paragraph of intro; track $index) {
            <p class="clause-text lead">{{ paragraph }}</p>
        }

        @for (section of sections; track section.title) {
            <article class="clause">
                <h2 class="clause-title">{{ section.title }}</h2>
                @for (paragraph of section.paragraphs; track $index) {
                    <p class="clause-text">{{ paragraph }}</p>
                }
                @if (section.bullets?.length) {
                    <ul class="clause-list">
                        @for (bullet of section.bullets; track $index) {
                            <li>{{ bullet }}</li>
                        }
                    </ul>
                }
            </article>
        } @empty {
            <p class="clause-text">{{ 'terms_empty' | translate }}</p>
        }
    </div>
</section>

<app-footer></app-footer>
